import { FilesService } from '../../files/FilesService'
import { OperationSpec } from './OperationContext'
import { RunnableOperation } from './RunnableOperation'

export class RunnableFileDelete extends RunnableOperation {
  constructor(userOpSpec: OperationSpec) {
    super(userOpSpec)
  }

  async execute(): Promise<void> {
    this.setStatus('running')
    if (this.aborted) {
      throw new Error('Operazione interrotta')
    }

    try {
      const response = await FilesService.deleteFile(this.userOpSpec)
      console.log('File eliminato con successo')

      console.log('Risposta del server:', response)
      this.setStatus('completed')
    } catch (error) {
      this.setStatus('error')
      throw new Error(
        `Errore durante l'eliminazione del file: ${(error as Error).message}`
      )
    }
  }

  abort(): void {
    this.aborted = true
  }
}
